import _ from "lodash";
import { checkAndUpdateToken } from "./auth";

import { BACKEND_URL_PREFIX } from "../utils/const";
import {
  GET_SCHEMA_ST,
  GET_YEARS_ST,
  GET_SCY_ST,
  GET_PERIOD_ST,
  MIN_MAX_RATING,
  MIN_MAX_RATING_LOADING,
  GET_INFO_ST,
  PHOTO_ST
} from "./types";
import { arrayBufferToBase64, buildDefaultHeaders } from "./helper";


export const trashRadar = () => dispatch => dispatch({ type: MIN_MAX_RATING, payload: null });
export const trashInfo = () => dispatch => dispatch({ type: GET_INFO_ST, payload: null });

export const getMinMax = (yearId, month, schema, type, id, scy) => async (dispatch, getState) => {

  dispatch({ type: MIN_MAX_RATING_LOADING, payload: true });

  let newMonth = null;
    let newMonth2 = null;
    let typeM = null;
    if(month.endsWith('_')) {
      newMonth2 = month.substring(0, month.length - 1).split(',').reverse().join('-');
      typeM = 2;
    } else {
      newMonth = month;
      typeM = 1;
    }
    
    const date = scy?.filter(el => el.xp_key == yearId)[0]?.begdate.split('-').reverse();
    const newDate = date?.filter((el, i) => i !== 1);
    if (newDate) newDate.splice(1, 0, newMonth);
    const dateAndMonth = newDate.map((el, i) => i < newDate.length - 1 ? `${el}-` : el).join('').split('-');
    
    if(Number(dateAndMonth[1]) < 9) {
      dateAndMonth[0] = Number(dateAndMonth[0]) + 1;
    }
    const newDateAndMonth =  dateAndMonth.join('-');

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/rating_edge/${schema}/${typeM}/${newMonth2 || newDateAndMonth}/${type}/${id}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: MIN_MAX_RATING, payload: data });
    dispatch({ type: MIN_MAX_RATING_LOADING, payload: false });
  }
};

export const getSchema = (yearId) => async (dispatch, getState) => {

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/rating_schema/${yearId}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_SCHEMA_ST, payload: data });
  }
};

export const getYears = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/edy`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: GET_YEARS_ST, response });

    if (response.ok) {
      const data = await response.json();

      dispatch({ type: GET_YEARS_ST, payload: data.educationYear });
    }
  }
};

export const schoolYear = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/scy`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GET_SCY_ST, payload: data.schoolYear });
    }
  }
};

export const getPeriod = (yearId) => async (dispatch, getState) => {

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/year/term/${yearId}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: GET_PERIOD_ST, payload: data });
  }
};

export const getInfo =
  (schema, group, year, month, scy) =>
  async (dispatch, getState) => {
    let newMonth = null;
    let newMonth2 = null;
    let type = null;
    if(month.endsWith('_')) {
      newMonth2 = month.substring(0, month.length - 1).split(',').reverse().join('-');
      type = 2;
    } else {
      newMonth = month;
      type = 1;
    }
    
    const date = scy.filter(el => el.xp_key == year)[0]?.begdate.split('-').reverse();
    const newDate = date?.filter((el, i) => i !== 1);
    if (newDate) newDate.splice(1, 0, newMonth);
    const dateAndMonth = newDate.map((el, i) => i < newDate.length - 1 ? `${el}-` : el).join('').split('-');
    
    if(Number(dateAndMonth[1]) < 9) {
      dateAndMonth[0] = Number(dateAndMonth[0]) + 1;
    }
    const newDateAndMonth =  dateAndMonth.join('-');

    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(
        `${BACKEND_URL_PREFIX}/rating_calc_details/${schema}/${group}/${newMonth2 || newDateAndMonth}/${type}`,
        {
          method: "GET",
          ...buildDefaultHeaders(getState),
        }
      );
      if (response.ok) {
        const data = await response.json();
        dispatch({ type:  GET_INFO_ST, payload: data });
      } else {
        console.log(`Error (getReport): ${response}`);
      }
    }
};

export const getPhoto = (PREFIX, mid) => async (dispatch, getState) => {

  const response = await fetch(
    `${PREFIX ? 
      `${PREFIX}users/${mid}/photo` : 
      `${BACKEND_URL_PREFIX}/users/${mid}/photo`}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const buffer = await response.arrayBuffer();
    const photo = arrayBufferToBase64(buffer);
    dispatch({ type: PHOTO_ST, payload: photo });
  } else {
    dispatch({ type: PHOTO_ST, payload: '' });
  }
};
